import { useRequest } from '../providers/useRequest';
import IUser from '../../interfaces/IUser';
import AppError from '../../errors/AppError';
import ITenantDomain from '../../interfaces/ITenantDomain';

const useTenantDomainService = () => {
  const request = useRequest<IUser>();
  const path = 'validate-tenant-name';
  const getTenantDomain = async (tenantDomain: ITenantDomain): Promise<ITenantDomain> => {
    return await request
      .post({ path, body: tenantDomain, sendAuthorization: false })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };
  return { getTenantDomain };
};

export { useTenantDomainService };
